import {useState} from "react";
import FormOpen from "./FormOpen";
import FormThanks from "./FormThanks";

export default function FormController(props){
    const [submitted, setSubmitted] = useState(false);
    const [formDataDebug, setFormDataDebug] = useState("{}");

    return <div className={"lg:w-1/2 xl:w-3/5 block bg-black"}>
        {submitted ? <FormThanks></FormThanks> : <FormOpen
            formName={props.formName}
            isCaptchaProtected={true || !props.devMode}
            debugSetter={setFormDataDebug}
            submittedSetter={setSubmitted}
            form={props.form}
            formHeader={props.formHeader}
            disclaimerText={props.disclaimerText}
        ></FormOpen> }

        { props.devMode ? <div className={"p-12"}>
            <h3 className={"text-2xl text-red-600"}>Dev Mode</h3>
            <p className={"text-red-600"}>Network errors will not be handled</p>
            <pre className={"bg-red-900 text-red-300 p-4"}>
                {formDataDebug}
            </pre>
        </div> : <div></div> }
    </div>;
}
